import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SimulationService } from '../../services/alert.service';
import { SimulationLP2ApiService } from '../../services/simulation-lp2-api.service';
import { VeiculoSimulationDTO } from '../../dtos/veiculo-simulation.dto';
import { ImovelSimulationDTO } from '../../dtos/imovel-simulation.dto';
import { getWhatsAppUrlLP2 } from '../../config/whatsapp.config';

declare global {
  interface Window { dataLayer: any[]; }
}

@Component({
  selector: 'app-navbar-2',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class Navbar2Component {
  isProcessing: boolean = false;

  constructor(
    private simulationService: SimulationService,
    private apiLP2Service: SimulationLP2ApiService,
    private router: Router
  ) { }

  isMenuOpen: boolean = false;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    document.body.style.overflow = '';
  }

  isVeiculosPage(): boolean {
    return this.router.url.includes('/veiculos-2');
  }

  isImoveisPage(): boolean {
    return this.router.url.includes('/imoveis-2');
  }

  getCurrentPageName(): string {
    if (this.isVeiculosPage()) {
      return 'Veículos';
    } else if (this.isImoveisPage()) {
      return 'Imóveis';
    }
    return 'Home';
  }

  onWhatsAppClick(): void {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'whatsapp_click',
        'category': 'contact',
        'label': 'navbar_2_button'
      });
    }

    window.open(getWhatsAppUrlLP2(), '_blank');
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  onSimulate() {
    const isImoveis = this.router.url.includes('imoveis');

    const beforeConfirm = async (formData: any) => {
      if (isImoveis) {
        const data: ImovelSimulationDTO = {
          name: formData.name,
          email: formData.email,
          telefone: formData.phone,
          valor: 'Não informado',
          tipoConsorcio: 'Imoveis'
        };
        return new Promise((resolve, reject) => {
          this.apiLP2Service.sendImovelSimulation2(data).subscribe({
            next: () => resolve(true),
            error: (err) => reject(err)
          });
        });
      } else {
        const data: VeiculoSimulationDTO = {
          name: formData.name,
          email: formData.email,
          telefone: formData.phone,
          valor: 'Não informado',
          tipoConsorcio: 'Veiculos'
        };
        return new Promise((resolve, reject) => {
          this.apiLP2Service.sendVeiculoSimulation2(data).subscribe({
            next: () => resolve(true),
            error: (err) => reject(err)
          });
        });
      }
    };

    this.simulationService.openSimulationModal('Faça sua Simulação', undefined, beforeConfirm).then(result => {
      if (result.isConfirmed) {
        this.simulationService.showSuccessAlert();
      }
    });
  }
}
